<!-- @ts-nocheck -->
<template>
  <div class="vendor-documents mt-4">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mb-3">
      <b-button
        variant="danger"
        size="sm"
        class="mr-2"
        :disabled="!hasSelected"
        @click="deleteSelected"
      >
        <i class="fas fa-trash-alt"></i>
        Delete Selected
      </b-button>
      <b-button variant="outline-primary" size="sm" @click="addRow">
        <i class="fas fa-plus"></i>
        Add New Row
      </b-button>
    </div>

    <!-- Native Table -->
    <table class="table align-middle">
      <thead class="thead-light">
        <tr>
          <th class="text-center" style="width: 40px">
            <b-form-checkbox
              :checked="
                documents?.every((doc) => doc?.selected) && documents.length > 0
              "
              @change="toggleAll"
            />
          </th>
          <th>Document Name</th>
          <th>Document Upload</th>
          <th style="width: 40px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(doc, index) in documents" :key="index">
          <td class="text-center">
            <b-form-checkbox v-model="doc.selected" @change="updateSelectAll" />
          </td>
          <td style="width: 45%">
            <b-form-select
              v-model="doc.document_name"
              :options="getAvailableDocumentOptions(index)"
              size="sm"
            >
              <template #first>
                <option :value="null" disabled>Select Document</option>
              </template>
            </b-form-select>
          </td>
          <td style="width: 45%">
            <div class="d-flex flex-column">
              <b-form-file
                v-model="doc.file_path"
                size="sm"
                browse-text="Browse"
                placeholder="Choose file..."
                @change="updateFileName(index)"
              />
              <div>
                <small>
                  File Type :
                  <b>.Pdf</b>
                </small>
                <span class="mx-2">|</span>
                <small>
                  Max File Size :
                  <b>25 MB</b>
                </small>
              </div>
            </div>
          </td>
          <td class="text-center">
            <b-button
              variant="link"
              size="sm"
              class="text-danger p-0"
              @click="deleteRow(index)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </td>
        </tr>

        <!-- Empty State -->
        <tr v-if="!documents || documents.length === 0">
          <td colspan="4" class="text-center p-4">
            <div class="empty-state">
              <i
                class="fas fa-file-alt text-muted mb-3"
                style="font-size: 3rem"
              ></i>
              <h6 class="text-muted mb-2">No Documents Added</h6>
              <p class="text-muted mb-3">
                Start by uploading your first document
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'VendorDocumentTable',
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectAll: false,
      documentOptions: ['NIB', 'KTP', 'NPWP', 'SIUPAL', 'SK KEMENKUMHAM'],
    }
  },
  computed: {
    hasSelected() {
      return (this.documents || []).some((doc) => doc.selected)
    },
  },
  methods: {
    getAvailableDocumentOptions(currentIndex) {
      // Dapatkan document yang sudah dipilih di row lain
      const selectedDocuments = this.documents
        .map((doc, index) => index !== currentIndex ? doc.document_name : null)
        .filter(name => name !== null)
      
      // Filter documentOptions untuk menghilangkan yang sudah dipilih
      const availableOptions = this.documentOptions.filter(option => 
        !selectedDocuments.includes(option)
      )
      
      // Jika document di current row sudah dipilih, tambahkan ke available options
      const currentDoc = this.documents[currentIndex]?.document_name
      if (currentDoc && !availableOptions.includes(currentDoc)) {
        availableOptions.push(currentDoc)
      }
      
      return availableOptions
    },
    emitDocuments(next) {
      this.$emit('update:documents', next)
    },
    addRow() {
      this.documents.push({
        selected: false,
        document_name: null,
        fileName: '',
        file_path: null,
        is_required: false,
      })
    },
    deleteRow(index) {
      this.documents.splice(index, 1)
    },
    deleteSelected() {
      this.$emit('deleteBulk')
      this.selectAll = false
    },
    toggleAll(val) {
      this.documents.forEach((doc) => {
        doc.selected = val
      })
    },
    updateSelectAll() {
      this.selectAll = (this.documents || []).every((doc) => doc.selected)
    },
    updateFileName(index) {
      const file = this.documents[index]?.file_path
      if (!file) return
      const next = this.documents.slice()
      next[index] = { ...next[index], fileName: file.name }
      this.emitDocuments(next)
    },
  },
}
</script>

<style scoped>
.table th {
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
}

.form-control,
.custom-select {
  font-size: 0.85rem;
}

.table td,
.table th {
  white-space: nowrap;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
